module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "l-section-n p-v-transition-ud episode"
  }, [_c('ul', {
    staticClass: "l-section-n c-tabmenu c-tabmenu_max-200 c-tabmenu_noborder u-ft-sz-s episode__select"
  }, _vm._l((_vm.episode_list), function(episode, index) {
    return _c('li', {
      key: index,
      staticClass: "c-tabmenu__item"
    }, [_c('router-link', {
      staticClass: " c-tabmenu__link ",
      attrs: {
        "to": {
          name: 'episode',
          params: {
            id: episode.id
          }
        }
      }
    }, [_c('span', {
      staticClass: "c-tabmenu__text "
    }, [_vm._v(_vm._s(episode.menu))])])], 1)
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "p-v-transition-ud"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_loading),
      expression: "!is_loading"
    }],
    staticClass: "p-v-transition-ud episode__content"
  }, [_c('header', {
    staticClass: "episode__header u-txt-center"
  }, [_c('h1', [_c('span', {
    staticClass: "episode__menu"
  }, [_vm._v(_vm._s(_vm.episode.menu))]), _vm._v(" "), _c('span', {
    staticClass: "episode__title"
  }, [_vm._v(_vm._s(_vm.episode.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "l-fx l-fx_wrap episode__images"
  }, _vm._l((_vm.episode.images), function(image, index) {
    return _c('div', {
      key: index,
      staticClass: "l-fx__item-3-1 l-fx__item-2-1-sp"
    }, [_c('img', {
      staticClass: "u-sz-w100",
      attrs: {
        "src": image,
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "l-section-n-sp"
  }, [_c('p', {
    staticClass: "episode__story",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.story)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "episode__staff u-txt-center",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.staff)
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ef717f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/story/episode-detail.vue
// module id = 51
// module chunks = 0